import React, { FC } from 'react';
import { TCardColumnLayoutProps, TCardFields } from './types/cardColumnLayout.types';
import { CardColumnLayoutModel } from './models/cardColumnLayout.model';
import { withSitecoreContext, Placeholder, ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import Card from './components/card';
import Heading from '../@shared/heading';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';
import UnreleasedComponent from '../@shared/unreleasedComponent';

const CardColumnLayout: FC<TCardColumnLayoutProps> = (props: TCardColumnLayoutProps) => {
  const model = new CardColumnLayoutModel(props);
  const isEE = !!props?.sitecoreContext?.pageEditing;

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <AnalyticsVisibleEvent rendering={props?.rendering} title={model.title?.value} template="Card Colum Layout">
      <div className="card-column-layout" style={{ backgroundColor: model.backgroundColor || '#fff' }}>
        <Heading
          eyebrow={model.eyebrow}
          title={model.title}
          subtitle={model.subtitle}
          link={model.link}
          customTextTitle
          tag={model?.headingTag}
          useAnalytics
          editable={true}
        >
          <div className="card-column-layout__pop-up">
            <Placeholder name={'jss-generic-popup'} rendering={props.rendering as ComponentRendering} />
          </div>
        </Heading>
        <div className={`card-column-layout__cards card-column-layout__cards--${model.layout}`}>
          {model.cards &&
            model.cards.map((card: TCardFields, index: number) => (
              <Card
                key={card.id ?? card.dataSource}
                cardIndex={index}
                id={card.id ?? card.dataSource}
                card={card.fields}
                layout={model.layout}
                isEE={isEE}
                triangle={model.whitetriangle}
                cardHeadingTag={model?.cardHeadingTitleTag}
              />
            ))}
        </div>
      </div>
    </AnalyticsVisibleEvent>
  );
};

export default withSitecoreContext()(CardColumnLayout);
